angular.module( 'acme.view.downtime', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.downtime.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var downtime = {
        name: 'downtime',
        url: '/downtime',
        views: {
          "main": {
            controller: 'DowntimeController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/downtime/downtime.tpl.html'
          }
        },
        data: {
          pageTitle: ' '
        }
      };

    $stateProvider
      .state(downtime);
});
